import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  Input,
  Button,
} from "@chakra-ui/react";

interface RenameJobModalProps {
  isOpen: boolean;
  onClose: () => void;
  newJobName: string;
  setNewJobName: (name: string) => void;
  handleRenameJob: () => void;
}

const RenameJobModal: React.FC<RenameJobModalProps> = ({
  isOpen,
  onClose,
  newJobName,
  setNewJobName,
  handleRenameJob,
}) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader fontSize="md">Update Job Name</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <FormControl>
          <Input
            placeholder="Enter Job name"
            value={newJobName}
            onChange={(e) => setNewJobName(e.target.value)}
          />
        </FormControl>
      </ModalBody>
      <ModalFooter>
        <Button colorScheme="purple" mr={3} onClick={handleRenameJob}>
          OK
        </Button>
        <Button variant="ghost" onClick={onClose}>
          Cancel
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default RenameJobModal;
